/**
 * Quick actions menu component
 * Uses callback props for navigation (no React Router dependency)
 */

import { DollarSign, TrendingDown, TrendingUp, PieChart } from 'lucide-react';
import { FloatingActionButton } from '../../../components/primitives';
import { usePermissions } from '../../../hooks/usePermissions';

interface QuickActionsMenuProps {
  onNavigateToNewTransaction?: (type?: 'income' | 'expense') => void;
  onNavigateToBudget?: () => void;
  onNavigateToTransactions?: () => void;
  className?: string;
}

export function QuickActionsMenu({ 
  onNavigateToNewTransaction,
  onNavigateToBudget,
  onNavigateToTransactions,
  className 
}: QuickActionsMenuProps) {
  const { canCreate } = usePermissions();
  
  const allActions = [
    {
      icon: TrendingUp,
      label: 'Nova Receita',
      onClick: () => onNavigateToNewTransaction?.('income'),
      variant: 'success' as const,
      requiresPermission: 'transactions' as const,
    },
    {
      icon: TrendingDown,
      label: 'Nova Despesa',
      onClick: () => onNavigateToNewTransaction?.('expense'),
      variant: 'danger' as const,
      requiresPermission: 'transactions' as const,
    },
    {
      icon: PieChart,
      label: 'Ver Orçamento',
      onClick: () => onNavigateToBudget?.(),
      variant: 'default' as const,
      requiresPermission: null, // Everyone can view
    },
    {
      icon: DollarSign,
      label: 'Ver Lançamentos',
      onClick: () => onNavigateToTransactions?.(),
      variant: 'default' as const,
      requiresPermission: null, // Everyone can view
    },
  ];

  // Filter actions based on permissions
  const actions = allActions.filter(action => {
    if (!action.requiresPermission) return true;
    return canCreate(action.requiresPermission);
  }).map(({ requiresPermission, ...action }) => action); // Remove permission field

  return <FloatingActionButton actions={actions} className={className} />;
}
